import { observable, action } from 'mobx'
import { has } from 'lodash'

interface LayoutItem {
  visible: boolean
}

class LayoutStore {
  @observable error: LayoutItem
  @observable actions: LayoutItem

  constructor() {
    this.error = {
      visible: false,
    }
    this.actions = {
      visible: false,
    }
  }

  @action
  updateError = (error: Partial<LayoutItem> = {}) => {
    has(error, 'visible') && (this.error.visible = error.visible!)
  }

  @action
  updateActions = (actions: Partial<LayoutItem> = {}) => {
    has(actions, 'visible') && (this.actions.visible = actions.visible!)
  }
}

export default new LayoutStore()
